
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DnsNSMap } from '@/services/DnsChecker';

@Component
export default class DnsNsMapPanel extends Vue {
  @Prop({ type: Object, required: true })
  public nsMap!: DnsNSMap;

  @Prop({ type: Boolean, default: false })
  public compact!: boolean;
}
